import { type SwooshColor, swooshColor } from "./SwooshBackground";
import { SwooshCurve } from "./SwooshCurve";

/** Compact decorative swoosh strip for mobile profile headers. Fixed 140px height, stretches to fill width. */
export interface SwooshStripProps {
  /** Color variant: red (family), yellow (community), purple (individual). */
  color: SwooshColor;
}

export function SwooshStrip({ color }: SwooshStripProps) {
  return (
    <div aria-hidden="true" className={swooshColor({ color, className: "h-[140px] w-full overflow-hidden" })}>
      <SwooshCurve className="size-full" />
    </div>
  );
}
